import { FP, RemoteData } from "../deps"

import { queryViewerCountry } from "./api"

const storageKey = "sa_country"

function getFromStorage(key: string): FP.io.IO<FP.option.Option<string>> {
  return () =>
    FP.option.fromNullable(
      window.localStorage &&
        window.localStorage.getItem &&
        window.localStorage.getItem(key)
    )
}

function putInStorage(key: string, value: string): FP.io.IO<string> {
  return () => {
    window.localStorage &&
      window.localStorage.setItem &&
      window.localStorage.setItem(key, value)
    return value
  }
}

let cache: FP.option.Option<string> = FP.option.none

type IOOption<A> = FP.io.IO<FP.option.Option<A>>
const ioOptionAlt: <A>(
  that: FP.function.Lazy<IOOption<A>>
) => (fa: IOOption<A>) => IOOption<A> = (that) =>
  FP.io.chain(FP.option.fold(that, FP.function.flow(FP.option.of, FP.io.of)))

export const getViewerCountry: () => FP.taskEither.TaskEither<Error, string> =
  FP.function.flow(
    () => () => cache,
    ioOptionAlt(() => getFromStorage(storageKey)),
    FP.taskEither.fromIO,
    FP.taskEither.chain(
      FP.option.fold(
        FP.function.flow(
          queryViewerCountry,
          FP.task.map(
            RemoteData.toEither(
              () =>
                new Error("Viewer country request could not complete: initial"),
              () =>
                new Error("Viewer country request could not complete: pending")
            )
          ),
          FP.taskEither.chainFirstIOK(
            (result) => () => (cache = FP.option.some(result))
          ),
          FP.taskEither.chainFirstIOK((result) =>
            putInStorage(storageKey, result)
          )
        ),
        FP.taskEither.of
      )
    )
  )
